<template>
  <div>
    <BaseText @input="emitSectionNameData($event)" :value="nameValue" placeholder="متن را اینجا وارد نمائید" required/>
    <div class="title">گزینه ها</div>
    <div v-for="(item, index) in items" :key="index" class="itemsStyle">
      <i v-if="items.length > 2" @click="removeRadioField(index)" class="removeIcon fa-regular fa-circle-xmark"></i>
      <BaseText @input="emitInputData($event, index)" :value="item.text" :placeholder="placeHolderGenerator(index)" required />
    </div>
    <div class="d-flex justify-content-end align-items-center">
      <div @click="addRadioOption()" class="addItemButton">+ اضافه کردن گزینه</div>
    </div>
  </div>
</template>

<script>
import BaseText from '@/components/common/form/formModules/BaseText.vue'
export default {
  components: {
    BaseText,
  },
  data() {
    return {
      inputData: {
        index: null,
        payload: null,
      },
    }
  },
  props: {
    items: {
      default: [
        {
          id: Math.random(),
          order: 0,
          value: null,
          text: null,
          mediaUrl: 'ییی',
          createdTime: '2021-10-20T08:21:52.0487087+00:00',
          lastUpdatedTime: '2021-10-20T08:21:52.0487091+00:00',
          rate: 0,
          isAvailable: true,
          isDeleted: false,
          defaultSelected: true,
        },
        {
          id: Math.random(),
          order: 1,
          value: null,
          text: null,
          mediaUrl: 'ییی',
          createdTime: '2021-10-20T08:21:52.0487087+00:00',
          lastUpdatedTime: '2021-10-20T08:21:52.0487091+00:00',
          rate: 0,
          isAvailable: true,
          isDeleted: false,
          defaultSelected: true,
        },
      ],
    },
    nameValue: {
      default: null,
    },
  },
  methods: {
    placeHolderGenerator(payload) {
      return `جواب ${payload + 1}`
    },
    emitInputData(payload, i) {
      this.inputData.payload = payload
      this.inputData.index = i
      this.$emit('inputsDataChanged', this.inputData)
    },
    emitSectionNameData(payload) {
      this.$emit('sectionNameChange', payload)
    },
    addRadioOption() {
      this.$emit('addRadioOptionClick')
    },
    removeRadioField(payload) {
      this.$emit('removeRadioFieldIndex', payload)
    },
  },
  computed: {},
}
</script>

<style scoped lang="scss">
.title {
  color: #495057;
  font-size: 13px;
  margin-bottom: 10px;
  margin-top: 20px;
}
.itemsStyle {
  margin-bottom: 20px;
  position: relative;
}
.itemsStyle:last-child {
  margin-bottom: 0px;
}
.removeIcon {
  color: #ff4861;
  font-size: 15px;
  cursor: pointer;
  position: absolute;
  right: -30px;
  top: 8px;
  z-index: 20;
}
.addItemButton {
  background: #ffffff;
  border: 1px solid #556ee6;
  border-radius: 4px;
  color: #556ee6;
  padding: 8px 18px;
  cursor: pointer;
  font-size: 13px;
}
</style>
